import { deleteStoredValue, getStoredValue, hasStoredValue, storeValue } from "../localStorage";
export var KEY = 'OnboardingProgramLevelFamily';
export function deleteStoredProgramLevelFamilies() {
  deleteStoredValue(KEY);
}
export function getStoredProgramLevelFamily() {
  return getStoredValue(KEY);
}
export function hasStoredProgramLevelFamilies() {
  return hasStoredValue(KEY);
}
export function storeProgramLevelFamilyValue(value) {
  storeValue(value, KEY);
}